import { render, staticRenderFns } from "./InfoSuspenso.vue?vue&type=template&id=777f29de&"
import script from "./InfoSuspenso.vue?vue&type=script&lang=js&"
export * from "./InfoSuspenso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports